(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["figur-listesi"] && !Shopify.designMode) return;
  try {
    /* Figür şeridi taşıyorsa (telefon) "kaydır" ipucunu, sağda ok ve solmayı gösterir; sona gelince gizler.
     Kaydırınca soldaki ok çıkar. Oklar şeridi bir ekran kaydırır. */
  if (!customElements.get('figur-kaydir')) {
    customElements.define('figur-kaydir', class extends HTMLElement {
      connectedCallback() {
        this.liste = this.querySelector('.figurler');
        this.ipucu = this.querySelector('.figurler__ipucu');
        if (!this.liste || !this.ipucu) return;
        this.guncelle = this.guncelle.bind(this);
        this.querySelectorAll('[data-yon]').forEach((b) =>
          b.addEventListener('click', () => {
            const yumusak = !matchMedia('(prefers-reduced-motion: reduce)').matches;
            this.liste.scrollBy({ left: +b.dataset.yon * this.liste.clientWidth * 0.8, behavior: yumusak ? 'smooth' : 'auto' });
          })
        );
        this.liste.addEventListener('scroll', this.guncelle, { passive: true });
        window.addEventListener('resize', this.guncelle);
        this.guncelle();
      }
      disconnectedCallback() {
        window.removeEventListener('resize', this.guncelle);
      }
      guncelle() {
        const l = this.liste;
        const tasiyor = l.scrollWidth - l.clientWidth > 8;
        const sonda = l.scrollLeft + l.clientWidth >= l.scrollWidth - 8;
        const basta = l.scrollLeft <= 8;
        this.ipucu.hidden = !tasiyor || sonda;
        this.querySelector('[data-yon="1"]').hidden = !tasiyor || sonda;
        this.querySelector('[data-yon="-1"]').hidden = !tasiyor || basta;
        this.toggleAttribute('data-devam', tasiyor && !sonda);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["galeri-buyutec"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('galeri-buyutec')) {
    const KAYDIRMA_ESIGI = 40;

    /* Yatay parmak hareketini algılar; dikey kaydırmaya ve iki parmağa karışmaz */
    const kaydirmaDinle = (alan, geri, ileri) => {
      let x0 = null;
      let y0 = null;
      alan.addEventListener('touchstart', (e) => {
        if (e.touches.length !== 1) return (x0 = null);
        x0 = e.touches[0].clientX;
        y0 = e.touches[0].clientY;
      }, { passive: true });
      alan.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        // İki parmakla yakınlaştırılmışken kaydırma görsel değiştirmez
        if (window.visualViewport && visualViewport.scale > 1.01) return (x0 = null);
        const dx = e.changedTouches[0].clientX - x0;
        const dy = e.changedTouches[0].clientY - y0;
        x0 = null;
        if (Math.abs(dx) < KAYDIRMA_ESIGI || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        alan.dataset.kaydirildi = '1';
        setTimeout(() => delete alan.dataset.kaydirildi, 350);
        (dx < 0 ? ileri : geri)();
      }, { passive: true });
    };

    let dialog = null;

    customElements.define(
      'galeri-buyutec',
      class extends HTMLElement {
        connectedCallback() {
          // Öğe ayrıştırılırken bağlanabilir; içindeki düğmeler hazır olunca başlat
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.baslat(), { once: true });
          } else {
            this.baslat();
          }
        }

        baslat() {
          if (this.hazir) return;
          this.hazir = true;
          this.ana = this.parentElement;
          this.galeri = this.closest('.galeri') || this.ana.parentElement;
          const dugmeler = this.dugmeler();
          const coklu = dugmeler.length > 1;
          this.querySelectorAll('[data-gez]').forEach((b) => {
            b.hidden = !coklu;
            b.addEventListener('click', () => this.gez(Number(b.dataset.gez)));
          });
          this.querySelector('[data-buyut]').addEventListener('click', () => this.ac());
          this.ana.addEventListener('click', (e) => {
            if (this.ana.dataset.kaydirildi) return;
            if (e.target.closest('.galeri__resim img')) this.ac();
          });
          if (coklu) {
            kaydirmaDinle(this.ana, () => this.gez(-1), () => this.gez(1));
            this.sayac = this.querySelector('[data-galeri-sayac]');
            new MutationObserver(() => this.sayacGuncelle()).observe(this.galeri, {
              subtree: true,
              attributes: true,
              attributeFilter: ['aria-pressed'],
            });
            this.sayacGuncelle();
          }
        }

        sayacGuncelle() {
          const d = this.dugmeler();
          const i = d.findIndex((b) => b.getAttribute('aria-pressed') === 'true');
          // Boyanmış renk görseli gösterilirken hiçbir küçük görsel seçili değildir
          this.sayac.hidden = i === -1;
          if (i !== -1) this.sayac.textContent = this.dataset.bkSayac.replace('[n]', i + 1).replace('[toplam]', d.length);
        }

        dugmeler() {
          return [...this.galeri.querySelectorAll('[data-goster]')];
        }

        gez(yon) {
          const d = this.dugmeler();
          if (d.length < 2) return;
          const i = d.findIndex((b) => b.getAttribute('aria-pressed') === 'true');
          const hedef = i === -1 ? (yon > 0 ? 0 : d.length - 1) : (i + yon + d.length) % d.length;
          d[hedef].click();
        }

        /* Görüntüleyiciye gidecek görseller: galerideki resimler, varsa boyanmış renk görseli başta */
        ogeler() {
          const liste = [];
          this.ana.querySelectorAll('.galeri__resim').forEach((kutu) => {
            const img = kutu.querySelector('img');
            if (!img) return;
            const renk = kutu.hasAttribute('data-renk-resim');
            if (renk && kutu.hidden) return;
            liste.push({
              // Boyanmış renk görselinde önce küçük önizleme yüklenir; büyük boyu adresten iste
              src: kutu.dataset.buyuk || (img.currentSrc || img.src).replace(/([?&])width=\d+/, '$1width=2000'),
              alt: img.alt,
              media: kutu.dataset.media,
              gorunur: !kutu.hidden,
              renk,
            });
          });
          liste.sort((a, b) => Number(b.renk) - Number(a.renk));
          return liste;
        }

        ac() {
          this.liste = this.ogeler();
          if (!this.liste.length) return;
          this.sira = Math.max(0, this.liste.findIndex((o) => o.gorunur));
          const d = this.pencere();
          d.sahibi = this;
          d.querySelector('.buyutec__kapat-metin').textContent = this.dataset.bkKapat;
          d.querySelector('[data-yon="-1"]').setAttribute('aria-label', this.dataset.bkOnceki);
          d.querySelector('[data-yon="1"]').setAttribute('aria-label', this.dataset.bkSonraki);
          d.setAttribute('aria-label', this.dataset.bkBaslik);
          d.querySelectorAll('.buyutec__ok').forEach((b) => (b.hidden = this.liste.length < 2));
          this.seritKur(d);
          this.ciz();
          d.showModal();
          // Geri tuşu ya da geri hareketi sayfadan çıkmasın, görüntüleyiciyi kapatsın
          history.pushState({ buyutec: true }, '');
          d.gecmisEklendi = true;
        }

        ciz() {
          const d = this.pencere();
          const o = this.liste[this.sira];
          const img = d.querySelector('.buyutec__resim');
          delete img.dataset.yakin;
          img.src = o.src;
          img.alt = o.alt;
          d.querySelectorAll('[data-sira]').forEach((b, i) => {
            b.setAttribute('aria-current', String(i === this.sira));
            if (i === this.sira) b.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          });
          d.querySelector('.buyutec__sayac').textContent = this.dataset.bkSayac
            .replace('[n]', this.sira + 1)
            .replace('[toplam]', this.liste.length);
          // Komşu görselleri önceden indir
          [1, -1].forEach((k) => {
            const komsu = this.liste[(this.sira + k + this.liste.length) % this.liste.length];
            if (komsu) new Image().src = komsu.src;
          });
        }

        seritKur(d) {
          const serit = d.querySelector('.buyutec__kucukler');
          serit.replaceChildren(
            ...this.liste.map((o, i) => {
              const b = document.createElement('button');
              b.type = 'button';
              b.dataset.sira = i;
              b.setAttribute('aria-label', this.dataset.bkSayac.replace('[n]', i + 1).replace('[toplam]', this.liste.length));
              const kucuk = document.createElement('img');
              const dugme = o.media !== undefined && this.galeri.querySelector(`[data-goster="${o.media}"] img`);
              kucuk.src = dugme ? dugme.currentSrc || dugme.src : o.src.replace(/([?&])width=\d+/, '$1width=200');
              kucuk.alt = '';
              kucuk.loading = 'lazy';
              b.append(kucuk);
              b.addEventListener('click', () => {
                this.sira = i;
                this.ciz();
              });
              return b;
            })
          );
        }

        cevir(yon) {
          if (this.liste.length < 2) return;
          this.sira = (this.sira + yon + this.liste.length) % this.liste.length;
          this.ciz();
        }

        /* Kapanınca ana galeri son bakılan görsele geçer */
        kapandi() {
          const o = this.liste && this.liste[this.sira];
          if (!o || o.renk || o.media === undefined) return;
          const b = this.dugmeler().find((x) => x.dataset.goster === o.media);
          if (b && b.getAttribute('aria-pressed') !== 'true') b.click();
        }

        pencere() {
          if (dialog) return dialog;
          dialog = document.createElement('dialog');
          dialog.className = 'buyutec';
          dialog.innerHTML = `
            <div class="buyutec__govde">
              <div class="buyutec__ust">
                <span class="buyutec__sayac" aria-live="polite"></span>
                <button type="button" class="buyutec__kapat">${this.querySelector('[data-simge-kapat]').innerHTML}<span class="buyutec__kapat-metin"></span></button>
              </div>
              <div class="buyutec__sahne">
                <img class="buyutec__resim" alt="" draggable="false">
                <button type="button" class="buyutec__ok buyutec__ok--geri" data-yon="-1">${this.querySelector('[data-gez="-1"]').innerHTML}</button>
                <button type="button" class="buyutec__ok buyutec__ok--ileri" data-yon="1">${this.querySelector('[data-gez="1"]').innerHTML}</button>
              </div>
              <div class="buyutec__kucukler" role="group"></div>
            </div>`;
          document.body.appendChild(dialog);
          const sahne = dialog.querySelector('.buyutec__sahne');
          const img = dialog.querySelector('.buyutec__resim');
          dialog.querySelector('.buyutec__kapat').addEventListener('click', () => dialog.close());
          dialog.querySelectorAll('[data-yon]').forEach((b) => b.addEventListener('click', () => dialog.sahibi.cevir(Number(b.dataset.yon))));
          dialog.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowLeft') dialog.sahibi.cevir(-1);
            if (e.key === 'ArrowRight') dialog.sahibi.cevir(1);
          });
          dialog.addEventListener('close', () => {
            delete img.dataset.yakin;
            dialog.sahibi.kapandi();
            // Düğme, Esc ya da boş alanla kapandıysa eklenen geçmiş kaydını geri al
            // Her açılış en fazla bir kez geri alınır; art arda kapanışlar sayfadan çıkarmaz
            if (dialog.gecmisEklendi && history.state && history.state.buyutec) history.back();
            dialog.gecmisEklendi = false;
          });
          window.addEventListener('popstate', () => {
            dialog.gecmisEklendi = false;
            if (dialog.open) dialog.close();
          });
          /* Tıklama görselin kendisinde mi? object-fit: contain ile kalan boşluklar görselden sayılmaz */
          const gorselde = (e) => {
            if (!img.naturalWidth) return true;
            const r = img.getBoundingClientRect();
            const st = getComputedStyle(img);
            const pl = parseFloat(st.paddingLeft);
            const pr = parseFloat(st.paddingRight);
            const pt = parseFloat(st.paddingTop);
            const pb = parseFloat(st.paddingBottom);
            const w = r.width - pl - pr;
            const h = r.height - pt - pb;
            const k = Math.min(w / img.naturalWidth, h / img.naturalHeight);
            const cw = img.naturalWidth * k;
            const ch = img.naturalHeight * k;
            const x = r.left + pl + (w - cw) / 2;
            const y = r.top + pt + (h - ch) / 2;
            return e.clientX >= x && e.clientX <= x + cw && e.clientY >= y && e.clientY <= y + ch;
          };
          // Görselin dışındaki boş alana tıklayınca kapanır
          sahne.addEventListener('click', (e) => {
            if (sahne.dataset.kaydirildi || e.target.closest('button')) return;
            if (e.target === sahne || (e.target === img && !img.dataset.yakin && !gorselde(e))) dialog.close();
          });
          // Masaüstünde tıklayınca 2 kat yakınlaştır; fare ile gezdir
          const fareli = matchMedia('(hover: hover) and (pointer: fine)').matches;
          const odak = (e) => {
            const r = img.getBoundingClientRect();
            img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
          };
          img.addEventListener('click', (e) => {
            if (!fareli || (!img.dataset.yakin && !gorselde(e))) return;
            if (img.dataset.yakin) return delete img.dataset.yakin;
            odak(e);
            img.dataset.yakin = '1';
          });
          img.addEventListener('mousemove', (e) => img.dataset.yakin && odak(e));
          kaydirmaDinle(sahne, () => dialog.sahibi.cevir(-1), () => dialog.sahibi.cevir(1));
          return dialog;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["galeri-ok"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('galeri-serit')) {
    customElements.define(
      'galeri-serit',
      class extends HTMLElement {
        connectedCallback() {
          // Öğe ayrıştırılırken bağlanabilir; içindeki liste hazır olunca başlat
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.baslat(), { once: true });
          } else {
            this.baslat();
          }
        }

        baslat() {
          if (this.hazir) return;
          this.hazir = true;
          this.liste = this.querySelector('.galeri__kucukler');
          this.oklar = this.querySelectorAll('[data-ok]');
          if (!this.liste) return;
          const yavas = matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.oklar.forEach((ok) =>
            ok.addEventListener('click', () =>
              this.liste.scrollBy({ left: Number(ok.dataset.ok) * this.liste.clientWidth, behavior: yavas ? 'auto' : 'smooth' })
            )
          );
          this.liste.addEventListener('scroll', () => this.durum(), { passive: true });
          new ResizeObserver(() => this.durum()).observe(this.liste);
          // Seçili küçük görsel değişince (ana görsel oklarla ya da renk seçimiyle) görünür alana kaydır
          new MutationObserver((kayitlar) => {
            const secili = kayitlar.map((k) => k.target).find((b) => b.getAttribute('aria-pressed') === 'true');
            if (secili) this.goster(secili.closest('li'));
          }).observe(this.liste, { subtree: true, attributes: true, attributeFilter: ['aria-pressed'] });
          this.durum();
          const ilk = this.liste.querySelector('[aria-pressed="true"]');
          if (ilk) this.goster(ilk.closest('li'), true);
        }
        durum() {
          const { scrollLeft, scrollWidth, clientWidth } = this.liste;
          const [geri, ileri] = this.oklar;
          if (geri) geri.disabled = scrollLeft <= 1;
          if (ileri) ileri.disabled = scrollLeft + clientWidth >= scrollWidth - 1;
        }
        goster(li, aninda) {
          if (!li) return;
          const sol = li.offsetLeft - this.liste.offsetLeft;
          const sag = sol + li.offsetWidth;
          const { scrollLeft, clientWidth } = this.liste;
          if (sol >= scrollLeft && sag <= scrollLeft + clientWidth) return;
          this.liste.scrollTo({ left: sol, behavior: aninda ? 'auto' : 'smooth' });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sepet-icerik"] && !Shopify.designMode) return;
  try {
    // Onay kutusu işaretlenmeden ödemeye geçilirse uyarı yazısı görünür; sepet yeniden çizilse de çalışsın diye belgeye bağlı
  document.addEventListener(
    'invalid',
    (e) => {
      if (!e.target.matches('[data-sepet-onay]')) return;
      const uyari = e.target.closest('form')?.querySelector('[data-sepet-onay-uyari]');
      if (uyari) uyari.hidden = false;
    },
    true
  );
  document.addEventListener('change', (e) => {
    if (!e.target.matches('[data-sepet-onay]') || !e.target.checked) return;
    const uyari = e.target.closest('form')?.querySelector('[data-sepet-onay-uyari]');
    if (uyari) uyari.hidden = true;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sonra-yukle"] && !Shopify.designMode) return;
  try {
    (() => {
    const yukle = () => {
      document.querySelectorAll('[data-sonra-yukle] img[loading="lazy"]').forEach((img) => {
        img.loading = 'eager';
      });
    };
    const bekle = () => ('requestIdleCallback' in window ? requestIdleCallback(yukle, { timeout: 3000 }) : setTimeout(yukle, 1500));
    if (document.readyState === 'complete') bekle();
    else window.addEventListener('load', bekle, { once: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["stok-haber"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('stok-haber')) {
    customElements.define(
      'stok-haber',
      class extends HTMLElement {
        /* Bülten formu da 'customer' formu olduğundan gönderim sonrası Liquid iki formda da "başarılı" der.
           Shopify dönüş adresine gönderilen formun kimliğini (#stok-haber-form) ekler; mesajı yalnız o form gösterir. */
        connectedCallback() {
          if (!new URLSearchParams(location.search).has('customer_posted')) return;
          const bizim = location.hash === '#stok-haber-form';
          const durum = this.querySelector('[data-durum]');
          if (!bizim) {
            durum.textContent = '';
            return;
          }
          const bulten = document.getElementById('footer-newsletter-status');
          if (bulten) bulten.textContent = '';
          this.querySelector('[data-alanlar]').hidden = true;
          /* Yapışkan çubuk bu düğmeyi izler; kayıttan sonra pasif "Kaydedildi" olarak kalır */
          const dugme = this.querySelector('[data-ekle]');
          dugme.textContent = JSON.parse(this.querySelector('[data-mesaj]').textContent).kayitli;
          dugme.disabled = true;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
